<template>
  <v-card class="mb-4">
    <v-card-title>Prices</v-card-title>
    <v-card-text>
        <v-simple-table>
          <template #default>
            <thead>
              <tr>
                <td>
                  Catalog
                </td>
                <td v-for="currency in currencies" :key="`currency_head_${currency.id}`">
                  {{ currency.currency }}
                </td>
              </tr>
            </thead>
            <tbody>
              <tr v-for="catalog in catalogs" :key="`row_${catalog.id}`">
                <td>
                  {{ catalog.name }}
                </td>
                <td v-for="currency in currencies" :key="`currency_row_${catalog.id}_${currency.id}`">
                  <div class="d-flex justify-between">
                    {{ prices(catalog, currency) }}
                    <PriceForm
                      :currency="currency"
                      :catalog="catalog"
                      :set="set"
                      @update="$emit('update')"
                      />
                  </div>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import PriceForm from "./PriceForm.vue";
export default {
    data: () => ({}),
    props: {
        set: {
            type: Object
        }
    },
    computed: {
        ...mapGetters("currencies", ["currencies"]),
        ...mapGetters("catalogs", ["catalogs"]),
    },
    mounted() {
    },
    methods: {
        prices(catalog, currency) {
            let price = null;
            for (let idx = 0; idx < this.set.products.length; idx++) {
                const product = this.set.products[idx];
                let productPrice = product.prices.find(p => p.catalog_id == catalog.id && p.currency == currency.currency);
                if (!productPrice && price) {
                    return 'Many';
                }
                if (productPrice && !price) {
                    price = productPrice.price;
                }
                else if (productPrice && price != productPrice.price) {
                    return 'Many';
                }
            }
            return price ? price : '-';
        }
    },
    components: { PriceForm }
};
</script>

<style>
</style>